import { render, staticRenderFns } from "./BindStaffSkill.vue?vue&type=template&id=420021f6&scoped=true"
import script from "./BindStaffSkill.vue?vue&type=script&lang=js"
export * from "./BindStaffSkill.vue?vue&type=script&lang=js"
import style0 from "./BindStaffSkill.vue?vue&type=style&index=0&id=420021f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420021f6",
  null
  
)

export default component.exports